import { useEffect, useMemo, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { VForm, useVForm } from "../../shered/forms";
import {
    Box, Tab, Tabs, Paper, Typography, useTheme,
    Table, TableBody, TableCell,
    TableContainer, TableFooter, TableHead,
    TableRow,
    tableCellClasses,
    LinearProgress
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { IDetalheJogadorFreeAgency, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { ILstDrop, TDropOptions, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { Loading } from "../../shered/components/loading/Loading";
import { DisputaService, IDadosClassificacao, IDadosClassificacaoGeralCopinha, IDadosRetornoClassificacoesCopinha } from "../../shered/services/api/disputa/DisputaService";
import { ptBR } from '@mui/x-data-grid/locales';
import { styled } from '@mui/material/styles';
import { ArrowDownward, ArrowUpward, Minimize, Remove } from "@mui/icons-material";
import { Liga } from "../ligas/Liga";
let temporadaAtual = 0;
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ?
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {
                    // value === index && (
                    <Box sx={{ p: 1 }}>
                        <Grid>{children}</Grid>
                    </Box>
                    //)
                }
            </div>
            : ""}
        </>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const ListagemDeClassificacao: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const { themeName } = useAppThemeContext();
    const { formRef, save, saveAndClose } = useVForm();
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [codigoFranquia, setCodigoFranquia] = useState(localStorage.getItem("@codigoFranquia"));
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [semImagemFranquia, setSemImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [nomePrimeiraConferencia, setNomePrimeiraConferencia] = useState("");
    const [nomeSegundaConferencia, setNomeSegundaConferencia] = useState("");

    //const [lstJogadores, setLstJogadores] = useState<TDropOptions[]>([]);
    //const [jogadorSelecionado, setJogadorSelecionado] = useState<number>(0);
    const [valorSalarioJogador, setValorSalarioJogador] = useState<string>("");
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [anoSelecionado, setAnoSelecionado] = useState<number>(0);
    const [value, setValue] = useState(0);
    const [codigoTemporadaAtual, setCodigoTemporadaAtual] = useState(0);
    const [aceitaEmpate, setAceitaEmpate] = useState(true);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [classificacaoGeralrows, setClassificacaoGeralrows] = useState<IDadosClassificacao[]>([]);
    const [classificacaoCopinharows, setClassificacaoCopinharows] = useState<IDadosClassificacaoGeralCopinha[]>([]);
    const [playIn, setPlayIn] = useState(false);
    const [qtdFranquias, setQtdFranquias] = useState(0);



    const [rowsConferencia1, setRowsConferencia1] = useState<IDadosClassificacao[]>([]);
    const [rowsConferencia2, setRowsConferencia2] = useState<IDadosClassificacao[]>([]);

    const [divisao1FranquiasRows, setDivisao1FranquiasRows] = useState<IDadosClassificacao[]>([]);
    const [divisao2FranquiasRows, setDivisao2FranquiasRows] = useState<IDadosClassificacao[]>([]);
    const [divisao3FranquiasRows, setDivisao3FranquiasRows] = useState<IDadosClassificacao[]>([]);
    const [divisao4FranquiasRows, setDivisao4FranquiasRows] = useState<IDadosClassificacao[]>([]);
    const [divisao5FranquiasRows, setDivisao5FranquiasRows] = useState<IDadosClassificacao[]>([]);
    const [divisao6FranquiasRows, setDivisao6FranquiasRows] = useState<IDadosClassificacao[]>([]);
    const [divisao7FranquiasRows, setDivisao7FranquiasRows] = useState<IDadosClassificacao[]>([]);
    const [divisao8FranquiasRows, setDivisao8FranquiasRows] = useState<IDadosClassificacao[]>([]);

    const [nomeDivisao1, setNomeDivisao1] = useState("");
    const [nomeDivisao2, setNomeDivisao2] = useState("");
    const [nomeDivisao3, setNomeDivisao3] = useState("");
    const [nomeDivisao4, setNomeDivisao4] = useState("");
    const [nomeDivisao5, setNomeDivisao5] = useState("");
    const [nomeDivisao6, setNomeDivisao6] = useState("");
    const [nomeDivisao7, setNomeDivisao7] = useState("");
    const [nomeDivisao8, setNomeDivisao8] = useState("");


    //const [historicoRows, setHistoricoRows] = useState<IListagemHistoricoLance[]>([]);

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    // const autoCompleteSelectedOption = useMemo(() => {
    //     if (!selectedIdComplete) return null;

    //     const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
    //     if (!selectedOption) return null;

    //     return selectedOption;
    // }, [selectedIdComplete, opcoesAutoCompleteJogador]);

    // const [errors, setErrors] = useState({
    //     error: false,
    //     nomeFranquiaRef: "",
    //     showImagemFranquia: ""

    // });

    // const CarregarDadosDisputa = () => {

    //     DisputaService.getAllPorCodigoLiga(Number(codigoLiga))
    //         .then((result) => {
    //             setIsLoading(false);
    //             let lstDivisao: IDadosDivisao[] = [];
    //             const disp = result.dado;
    //             //console.log(result.dado);
    //             // exibirTabelasFranquias = tipo === 1 && disp.liberacoes_Liga.data_Sorteio_Franquia !== null || (disp.liberacoes_Liga.data_Sorteio_Franquia !== undefined && new Date(disp.liberacoes_Liga.data_Sorteio_Franquia) <= new Date()) ? true : false;
    //             // setLstConferenciasRows(disp.conferencia);
    //             // setTipoEdit(false);

    //             // if (disp.conferencia.length === 2) {
    //             //     setLiberarEdicao(true);
    //             // }
    //             // setTipo(disp.liberacoes_Liga.data_Sorteio_Franquia !== null ? 1 : 2);
    //             // disp.conferencia.map((f, c) => {
    //             //     if (c === 0) {
    //             //         setConferencia1(f.nome);
    //             //         setCodigo_Conferencia1(Number(f.codigo));
    //             //         setEdicao(true);

    //             //     } else {
    //             //         setConferencia2(f.nome);
    //             //         setCodigo_Conferencia2(Number(f.codigo));
    //             //         setEdicao(true);
    //             //     }
    //             //     if (f.divisao.length > 0) {
    //             //         setLstTodasFranquias(result.dado.franquia);
    //             //         f.divisao.map((d, i) => {
    //             //             let lstFranquia = result.dado.franquia.filter(m => m.codigo_Divisao === d.codigo && m.codigo_Conferencia === f.codigo)
    //             //             let codFranquia = 0;
    //             //             lstDivisao.push(d);
    //             //             if (c === 0) {

    //             //                 setEdicao(true);
    //             //                 if (i === 0) {
    //             //                     setDivisao1(d.nome);
    //             //                     setCodigo_conf1_divisao1(Number(d.codigo));
    //             //                     setDivisao1FranquiasRows(lstFranquia);
    //             //                     lstFranquia.map((k, i) => {
    //             //                         codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
    //             //                         eval(`setDropFranquia1${i}(codFranquia)`);
    //             //                     });
    //             //                 }
    //             //                 else if (i === 1) {
    //             //                     setDivisao2(d.nome);
    //             //                     setCodigo_conf1_divisao2(Number(d.codigo));
    //             //                     setDivisao2FranquiasRows(lstFranquia);
    //             //                     lstFranquia.map((k, i) => {
    //             //                         codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
    //             //                         eval(`setDropFranquia2${i}(codFranquia)`);
    //             //                     });

    //             //                 }
    //             //                 else if (i === 2) {
    //             //                     setDivisao3(d.nome);
    //             //                     setCodigo_conf1_divisao3(Number(d.codigo));
    //             //                     setDivisao3FranquiasRows(lstFranquia);

    //             //                     lstFranquia.map((k, i) => {
    //             //                         codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
    //             //                         eval(`setDropFranquia3${i}(codFranquia)`);
    //             //                     });
    //             //                 }
    //             //                 else {
    //             //                     setDivisao4(d.nome);
    //             //                     setCodigo_conf1_divisao4(Number(d.codigo));
    //             //                     setDivisao4FranquiasRows(lstFranquia);
    //             //                     lstFranquia.map((k, i) => {
    //             //                         codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
    //             //                         eval(`setDropFranquia4${i}(codFranquia)`);
    //             //                     });
    //             //                 }
    //             //             }
    //             //             else {
    //             //                 setEdicao(true);
    //             //                 if (i === 0) {
    //             //                     setDivisao5(d.nome);
    //             //                     setCodigo_conf2_divisao1(Number(d.codigo));
    //             //                     setDivisao5FranquiasRows(lstFranquia);
    //             //                     lstFranquia.map((k, i) => {
    //             //                         codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
    //             //                         eval(`setDropFranquia5${i}(codFranquia)`);
    //             //                     });
    //             //                 }
    //             //                 else if (i === 1) {
    //             //                     setDivisao6(d.nome);
    //             //                     setCodigo_conf2_divisao2(Number(d.codigo));
    //             //                     setDivisao6FranquiasRows(lstFranquia);
    //             //                     lstFranquia.map((k, i) => {
    //             //                         codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
    //             //                         eval(`setDropFranquia6${i}(codFranquia)`);
    //             //                     });
    //             //                 }
    //             //                 else if (i === 2) {
    //             //                     setDivisao7(d.nome);
    //             //                     setCodigo_conf2_divisao3(Number(d.codigo));
    //             //                     setDivisao7FranquiasRows(lstFranquia);
    //             //                     lstFranquia.map((k, i) => {
    //             //                         codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
    //             //                         eval(`setDropFranquia7${i}(codFranquia)`);
    //             //                     });
    //             //                 }
    //             //                 else {
    //             //                     setDivisao8(d.nome);
    //             //                     setCodigo_conf2_divisao4(Number(d.codigo));
    //             //                     setDivisao8FranquiasRows(lstFranquia);
    //             //                     lstFranquia.map((k, i) => {
    //             //                         codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
    //             //                         eval(`setDropFranquia8${i}(codFranquia)`);
    //             //                     });
    //             //                 }
    //             //             }
    //             //         });
    //             //     }
    //             // });
    //         })
    //         .catch((errors) => {
    //             setShowModalMensagem(true);
    //             setRemoveLoading(true);
    //             //console.log(errors);
    //             if (errors.response !== undefined && errors.response.data.statusHTTP === 401) {
    //                 setDadosModalMensagem({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "info",
    //                     mensagem: "Sessão expirada!",
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //                 logout();
    //                 setRedirecionar("0");
    //                 return;
    //             }
    //             if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
    //                 setDadosModalMensagem({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "info",
    //                     mensagem: errors.response.data.mensagem,
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //                 setRedirecionar("/ligas");
    //                 return;
    //             }
    //             else {
    //                 setDadosModalMensagem({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "info",
    //                     mensagem: "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI ",
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //                 setRedirecionar("/ligas");
    //                 return;
    //             }
    //         });
    //     setRemoveLoading(true);
    // }

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            fontSize: UtilidadeService.isMobile() ? 12 : 13,
            fontWeight: '600',
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: UtilidadeService.isMobile() ? 12 : 13,
            fontWeight: '600',
            padding: "5px "
        },
        [`&.${tableCellClasses.footer}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        }
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td': {
            border: 0,
        },
        '&:last-child th': {
            border: 0,
            padding: "12px 8px "
        },
    }));

    const columns: GridColDef[] = [
        {
            field: 'posicao', headerName: '',
            flex: 1,
            minWidth: 33,
            // maxWidth: 40,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                            display: "flex",
                            justifyContent: "center"
                        }}
                    >
                        {(params.row.posicao_Anterior === 0 ? <>{params.value}<Remove sx={{ color: "#fbc02d", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /></> : params.row.posicao < params.row.posicao_Anterior ?
                            <>{params.value}<ArrowUpward sx={{ color: "#66bb6a", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /> <span style={{ color: "#66bb6a", fontSize: UtilidadeService.isMobile() ? "small" : "small" }}>{Number(params.row.posicao_Anterior - params.row.posicao)}</span> </>
                            : params.row.posicao > params.row.posicao_Anterior ?
                                <>{params.value}<ArrowDownward sx={{ color: "#E91309", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /> <span style={{ color: "#E91309", fontSize: UtilidadeService.isMobile() ? "small" : "small" }}>{Number(params.row.posicao - params.row.posicao_Anterior)}</span> </>
                                : <>{params.value}<Remove sx={{ color: "#fbc02d", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /></>)}
                    </Box>
                );
            },
        },
        {
            field: 'logo_Franquia',
            headerName: '',
            hideable: false,
            minWidth: UtilidadeService.isMobile() ? 45 : 65,
            // maxWidth: 65,
            flex: 1,
            renderCell: (params) => <img src={params.value !== null ? params.value : semImagemFranquia} width={UtilidadeService.isMobile() ? 25 : 45} height={UtilidadeService.isMobile() ? 30 : 50} />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                const color = params.row.posicao <= 6 ? "auto"
                    : playIn
                        ? qtdFranquias === 24 && params.row.posicao > 6 && params.row.posicao <= 9 ? "#dc7151"
                            : qtdFranquias === 30 && params.row.posicao > 6 && params.row.posicao <= 10 ? "#dc7151"
                                : params.row.posicao <= 8 ? "auto" : "#4864E8"
                        : params.row.posicao <= 8 ? "auto" : "#4864E8"
                return (
                    <Box
                        sx={{
                            color: color,
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'pontos',
            headerName: 'PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 45,
            //   maxWidth: 55,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            cellClassName: 'super-app-theme--cell'
        },
        {
            field: 'quantidade_Vitorias',
            headerName: 'V',
            headerClassName: 'super-app-theme--header',
            editable: false,
            flex: 1,
            minWidth: 35,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'quantidade_Empates',
            headerName: 'E',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 35,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'quantidade_Derrotas',
            headerName: 'D',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 35,
            //  maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        }
    ];

    const columnsDivs: GridColDef[] = [
        {
            field: 'posicao', headerName: '',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 30 : 40,
            //   maxWidth: 40,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                            display: "flex",
                            justifyContent: "center"
                        }}
                    >
                        {(params.row.posicao_Anterior === 0 ? <>{params.value}<Remove sx={{ color: "#fbc02d", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /></> : params.row.posicao < params.row.posicao_Anterior ?
                            <>{params.value}<ArrowUpward sx={{ color: "#66bb6a", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /> <span style={{ color: "#66bb6a", fontSize: UtilidadeService.isMobile() ? "small" : "small" }}>{Number(params.row.posicao_Anterior - params.row.posicao)}</span> </>
                            : params.row.posicao > params.row.posicao_Anterior ?
                                <>{params.value}<ArrowDownward sx={{ color: "#E91309", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /> <span style={{ color: "#E91309", fontSize: UtilidadeService.isMobile() ? "small" : "small" }}>{Number(params.row.posicao - params.row.posicao_Anterior)}</span> </>
                                : <>{params.value}<Remove sx={{ color: "#fbc02d", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /></>)}
                    </Box>
                );
            },
        },
        {
            field: 'logo_Franquia',
            headerName: '',
            minWidth: UtilidadeService.isMobile() ? 35 : 65,
            //   maxWidth: 65,
            flex: 1,
            renderCell: (params) => <img src={params.value !== null ? params.value : semImagemFranquia} width={45} height={50} />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                const color = params.row.posicao <= 8 ? "auto" : "#4864E8";
                return (
                    <Box
                        sx={{
                            color: color,
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'pontos',
            headerName: 'PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 55,
            //   maxWidth: 55,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            cellClassName: 'super-app-theme--cell'
        },
        {
            field: 'quantidade_Vitorias',
            headerName: 'V',
            headerClassName: 'super-app-theme--header',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 40,
            //   maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'quantidade_Empates',
            headerName: 'E',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 40,
            //   maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,

        },
        {
            field: 'quantidade_Derrotas',
            headerName: 'D',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 40,
            //   maxWidth: 40,
            align: 'center',
            headerAlign: 'center',
            sortable: false,

        },

    ];

    const columnsGeral: GridColDef[] = [
        {
            field: 'posicao', headerName: '',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 40,
            //   maxWidth: 40,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                            display: "flex",
                            justifyContent: "center"
                        }}
                    >
                        {(params.row.posicao_Anterior === 0 ? <>{params.value}<Remove sx={{ color: "#fbc02d", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /></> : params.row.posicao < params.row.posicao_Anterior ?
                            <>{params.value}<ArrowUpward sx={{ color: "#66bb6a", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /> <span style={{ color: "#66bb6a", fontSize: UtilidadeService.isMobile() ? "small" : "small" }}>{Number(params.row.posicao_Anterior - params.row.posicao)}</span> </>
                            : params.row.posicao > params.row.posicao_Anterior ?
                                <>{params.value}<ArrowDownward sx={{ color: "#E91309", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /> <span style={{ color: "#E91309", fontSize: UtilidadeService.isMobile() ? "small" : "small" }}>{Number(params.row.posicao - params.row.posicao_Anterior)}</span> </>
                                : <>{params.value}<Remove sx={{ color: "#fbc02d", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /></>)}
                    </Box>
                );
            },
        },
        {
            field: 'logo_Franquia',
            headerName: 'LOGO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 65,
            //   maxWidth: 65,
            renderCell: (params) => <img src={params.value !== null ? params.value : semImagemFranquia} width={45} height={50} />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            editable: false,
            flex: 1,
            headerClassName: 'super-app-theme--header',
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            sortable: false,
            renderCell: (params) => {
                const color = params.row.posicao <= 8 ? "auto" : "#4864E8";
                return (
                    <Box
                        sx={{
                            color: color,
                            fontWeight: 'bold',
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        // {
        //     field: 'posicao_Anterior',
        //     headerName: '-',
        //     flex: 1,
        //     headerClassName: 'super-app-theme--header',
        //     minWidth: UtilidadeService.isMobile() ? 60 : 70,
        //     sortable: false,

        // },
        {
            field: 'pontos',
            headerName: 'PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 55,
            //maxWidth: 55,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            cellClassName: 'super-app-theme--cell'
        },
        {
            field: 'quantidade_Vitorias',
            headerName: 'V',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 40,
            //maxWidth: 40,
            editable: false,
            align: 'center',
            sortable: false,
            headerAlign: 'center'
        },
        {
            field: 'quantidade_Empates',
            headerName: 'E',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 40,
            //maxWidth: 40,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            sortable: false,
            headerAlign: 'center'
        },
        {
            field: 'quantidade_Derrotas',
            headerName: 'D',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 40,
            //maxWidth: 40,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            sortable: false,
            headerAlign: 'center'
        },

        {
            field: 'vitorias_Divisao',
            headerName: 'V. Div.',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 55,
            //maxWidth: 55,
            align: 'center',
            headerAlign: 'center',
            sortable: false,

        },
        {
            field: 'vitorias_Conferencia',
            headerName: 'V. Conf.',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 55,
            //maxWidth: 55,
            align: 'center',
            headerAlign: 'center',
            sortable: false,

        },
        {
            field: 'saldo_Vitorias',
            headerName: 'SALDO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 55,
            //maxWidth: 55,
            align: 'center',
            headerAlign: 'center',
            sortable: false,

        }
    ];

    useEffect(() => {
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        setIsLoading(true);
        const fetchData = async () => {
            await UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const tmps = result.data.dado;
                    let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                    setLstTemporadas(lstTemporadasAux);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    console.log(liga);
                    setDadosLiga(liga);
                    setCodigoTemporadaAtual(liga.codigo_Temporada);
                    CarregarClassificacoes(liga.codigo, liga.codigo_Temporada);
                    setAceitaEmpate(!liga.aceita_Empate);
                    setPlayIn(liga.play_In);
                    setQtdFranquias(liga.quantidade_Franquia);
                    temporadaAtual = liga.codigo_Temporada;
                    if (liga.caminho_Logo !== null) {
                        setShowImagemFranquia(liga.caminho_Logo);
                    }
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    //setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });
        }
        fetchData();
        setRemoveLoading(true);

    }, [codigoLiga]);

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        setCodigoTemporadaAtual(e.target.value);
        CarregarClassificacoes(Number(codigoLiga), e.target.value);
    };

    const CarregarClassificacoes = (codigoLiga: number, codigoTemporada: number) => {

        if (codigoTemporada === 0) {
            return;
        }
        DisputaService.getClassificacaoPorCodigoLigaTemporada(codigoLiga, codigoTemporada)
            .then((result) => {
                setIsLoading(false);
                const dadosClassificacao = result.dado;
                // console.log("Classificação");
                // console.log(dadosClassificacao);
                setClassificacaoGeralrows(dadosClassificacao.classificacao_Geral.classificacao_Geral);
                setRowsConferencia1(dadosClassificacao.classificacao_Conferencia.classificacao_Conferencia1);
                setNomePrimeiraConferencia(dadosClassificacao.classificacao_Conferencia.nome_Conferencia1);
                setRowsConferencia2(dadosClassificacao.classificacao_Conferencia.classificacao_Conferencia2);
                setNomeSegundaConferencia(dadosClassificacao.classificacao_Conferencia.nome_Conferencia2);

                setNomeDivisao1(dadosClassificacao.classificacao_Divisao.nome_Divisao1);
                setDivisao1FranquiasRows(dadosClassificacao.classificacao_Divisao.classificacao_Divisao1 !== undefined ? dadosClassificacao.classificacao_Divisao.classificacao_Divisao1 : []);
                setNomeDivisao2(dadosClassificacao.classificacao_Divisao.nome_Divisao2);
                setDivisao2FranquiasRows(dadosClassificacao.classificacao_Divisao.classificacao_Divisao2 !== undefined ? dadosClassificacao.classificacao_Divisao.classificacao_Divisao2 : []);
                setNomeDivisao3(dadosClassificacao.classificacao_Divisao.nome_Divisao3);
                setDivisao3FranquiasRows(dadosClassificacao.classificacao_Divisao.classificacao_Divisao3 !== undefined ? dadosClassificacao.classificacao_Divisao.classificacao_Divisao3 : []);
                setNomeDivisao4(dadosClassificacao.classificacao_Divisao.nome_Divisao4);
                setDivisao4FranquiasRows(dadosClassificacao.classificacao_Divisao.classificacao_Divisao4 !== undefined ? dadosClassificacao.classificacao_Divisao.classificacao_Divisao4 : []);
                setNomeDivisao5(dadosClassificacao.classificacao_Divisao.nome_Divisao5);
                setDivisao5FranquiasRows(dadosClassificacao.classificacao_Divisao.classificacao_Divisao5 !== undefined ? dadosClassificacao.classificacao_Divisao.classificacao_Divisao5 : []);
                setNomeDivisao6(dadosClassificacao.classificacao_Divisao.nome_Divisao6);
                setDivisao6FranquiasRows(dadosClassificacao.classificacao_Divisao.classificacao_Divisao6 !== undefined ? dadosClassificacao.classificacao_Divisao.classificacao_Divisao6 : []);
                setNomeDivisao7(dadosClassificacao.classificacao_Divisao.nome_Divisao7);
                setDivisao7FranquiasRows(dadosClassificacao.classificacao_Divisao.classificacao_Divisao7 !== undefined ? dadosClassificacao.classificacao_Divisao.classificacao_Divisao7 : []);
                setNomeDivisao8(dadosClassificacao.classificacao_Divisao.nome_Divisao8);
                setDivisao8FranquiasRows(dadosClassificacao.classificacao_Divisao.classificacao_Divisao8 !== undefined ? dadosClassificacao.classificacao_Divisao.classificacao_Divisao8 : []);

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                //setRedirecionar("/ligas");
                return;
            });

        DisputaService.getClassificacaoCopinhaPorCodigoLigaTemporada(codigoLiga, codigoTemporada)
            .then((result) => {
                setIsLoading(false);
                const dadosClassificacao = result.dado;
                // console.log("Classificação");
                // console.log(dadosClassificacao);
                setClassificacaoCopinharows(dadosClassificacao.grupos);

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                //setRedirecionar("/ligas");
                return;
            });

    }

    const handleSave = async (dados: any) => {
        const liga = dadosLiga !== null && dadosLiga !== undefined ? dadosLiga : null;
        if (liga === null) {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }

        const dadosSalvar: IDetalheJogadorFreeAgency = {
            codigo_Franquia: liga?.codigo_Franquia,
            codigo_Free_Agency: liga?.codigo_Free_Agency,
            codigo_Jogador: Number(selectedIdComplete),
            tempo_Contrato: anoSelecionado,
            valor: valorSalarioJogador
        }

        JogadorService.CreateJogadorFreeAgency(dadosSalvar)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Lance salvo com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar("0");
            })
            .catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível cadastrar os dados do lance! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            // FranquiaService.deleteById(id)
            //     .then((result) => {
            //         setShowModalMensagem(true);
            //         setDadosModalMensagem({
            //             acao: true,
            //             label: "",
            //             tipo: "success",
            //             mensagem: "Registro excluido com sucesso!",
            //             display: "none",
            //             titulo: "Atenção"
            //         });
            //         setRedirecionar("/franquias");
            //     })
            //     .catch((errors) => {
            //         setShowModalMensagem(true);
            //         if (errors.response.data.statusHTTP === 401) {
            //             logout();
            //             setDadosModalMensagem({
            //                 acao: true,
            //                 label: "",
            //                 tipo: "error",
            //                 mensagem: "Sessão expirada!",
            //                 display: "none",
            //                 titulo: "Atenção"
            //             });
            //             setRedirecionar("0");;
            //             return;
            //         }
            //         setDadosModalMensagem({
            //             acao: true,
            //             label: "",
            //             tipo: "error",
            //             mensagem: errors.response.data.mensagem,
            //             display: "none",
            //             titulo: "Atenção"
            //         });
            //     });
        }
    }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };


    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "0");
    }, [searchParams]);


    return (
        <LayoutBaseDePagina
            titulo={`Classificação - ${dadosLiga?.nome}`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoSalvar={false}
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmApagar={() => handleDelete(Number(codigoFranquia))}
                    aoClicarEmNovo={() => navigate("/freeagency/detalhe/nova")}
                    aoClicarEmVoltar={() => navigate(`/usuario/liga/${codLocal}`)}
                />
            }
        >
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid size={{ xs: 12, sm: 12 }} >
                            <Typography variant="h6">Clasificação por temporada</Typography>
                            <hr />
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial">
                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                <SelectComponent
                                    required
                                    isExternalLoading={isLoading}
                                    label="Temporadas"
                                    name="codigo_Temporada_Picks"
                                    items={lstTemporadas}
                                    value={codigoTemporadaAtual}
                                    defaultValue={temporadaAtual}
                                    variant="outlined"
                                    onChange={handleSelectedTemporada}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid alignItems="center" justifyContent="center" width="100%">
                            <Paper>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={value} onChange={handleChangeTabs} centered variant="fullWidth">
                                        <Tab label="Conferência" {...a11yProps(0)} />
                                        <Tab label="Divisão" {...a11yProps(1)} />
                                        <Tab label="Liga"  {...a11yProps(2)} />
                                        <Tab label="Copinha" disabled={!dadosLiga?.copinha_Sorteada}  {...a11yProps(3)} />
                                    </Tabs>
                                </Box>
                                <TabPanel value={value} index={0} >
                                    {!removeLoading && <Loading />}
                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" padding={0}>
                                        <Grid container size={{ xs: 12, sm: 6 }} textAlign="initial" >
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} >
                                                <Typography variant="h6">{nomePrimeiraConferencia}</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} style={{ width: "100%" }}>
                                                <Grid margin={1} paddingBottom={1}>
                                                    {!removeLoading && <Loading />}
                                                </Grid>
                                                <Box padding={0}
                                                    sx={{
                                                        width: "100%",
                                                        height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                        '& .super-app-theme--header': {
                                                            backgroundColor: theme.palette.common.black,
                                                            color: theme.palette.common.white,
                                                        },
                                                        '& .super-app.negative': {
                                                            color: 'red',
                                                            fontWeight: 'bold'
                                                        },
                                                        '& .super-app.positive': {
                                                            color: themeName === "light" ? "black" : "auto",
                                                        },
                                                        '& .super-app-theme--cell': {
                                                            color: '#00e676',
                                                            fontWeight: '600',
                                                        },
                                                    }}>
                                                    <DataGrid
                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                        getRowId={(r) => r.codigo_Franquia}
                                                        rows={rowsConferencia1}
                                                        columns={columns}
                                                        initialState={{
                                                            pagination: {
                                                                paginationModel: {
                                                                    pageSize: 16,
                                                                    page: pagina,
                                                                },
                                                            },
                                                        }}
                                                        columnVisibilityModel={{
                                                            logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                            quantidade_Empates: aceitaEmpate ? true : false
                                                        }}
                                                        pageSizeOptions={[16]}
                                                        disableRowSelectionOnClick
                                                        disableVirtualization
                                                        disableColumnFilter
                                                        disableColumnMenu
                                                        sx={{
                                                            fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                        }}

                                                    />
                                                </Box>
                                            </Grid>

                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 6 }} textAlign="initial" >
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} >
                                                <Typography variant="h6">{nomeSegundaConferencia}</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }}>
                                                <Grid margin={1} paddingBottom={1}>
                                                    {!removeLoading && <Loading />}
                                                </Grid>
                                                <Box
                                                    sx={{
                                                        height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                        '& .super-app-theme--header': {
                                                            backgroundColor: theme.palette.common.black,
                                                            color: theme.palette.common.white,
                                                        },
                                                        '& .super-app.negative': {
                                                            color: 'red',
                                                            fontWeight: 'bold'
                                                        },
                                                        '& .super-app.positive': {
                                                            color: themeName === "light" ? "black" : "auto",
                                                        },
                                                        '& .super-app-theme--cell': {
                                                            color: '#00e676',
                                                            fontWeight: '600',
                                                        },
                                                    }}>
                                                    <DataGrid
                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                        getRowId={(r) => r.codigo_Franquia}
                                                        rows={rowsConferencia2}
                                                        columns={columns}
                                                        initialState={{
                                                            pagination: {
                                                                paginationModel: {
                                                                    pageSize: 16,
                                                                    page: pagina,
                                                                },
                                                            },
                                                        }}

                                                        pageSizeOptions={[16]}
                                                        disableRowSelectionOnClick
                                                        disableColumnFilter
                                                        disableColumnMenu
                                                        columnVisibilityModel={{
                                                            logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                            quantidade_Empates: aceitaEmpate ? true : false
                                                        }}
                                                        sx={{
                                                            fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    <Grid container size={{ xs: 12, sm: 12 }}>
                                        <Grid container marginTop={1} size={{ xs: 12, sm: 6 }}>
                                            {!removeLoading && <Loading />}
                                            <Grid container padding={1}>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Typography variant="h6">{`${nomeDivisao1} (${nomePrimeiraConferencia})`}</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                    <Box
                                                        sx={{
                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white
                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                color: themeName === "light" ? "black" : "auto",
                                                            },
                                                            '& .super-app-theme--cell': {
                                                                color: '#00e676',
                                                                fontWeight: '600',
                                                            },
                                                        }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            getRowId={(rows) => rows.codigo_Franquia}
                                                            rows={divisao1FranquiasRows}
                                                            columns={columnsDivs}

                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: {
                                                                        pageSize: 32,
                                                                        page: pagina,
                                                                    },
                                                                },
                                                            }}
                                                            pageSizeOptions={[32]}
                                                            // //checkboxSelection
                                                            disableRowSelectionOnClick
                                                            disableColumnFilter
                                                            disableColumnMenu
                                                            columnVisibilityModel={{
                                                                logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                                quantidade_Empates: aceitaEmpate ? true : false
                                                            }}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <Grid container padding={1}>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Typography variant="h6">{`${nomeDivisao2} (${nomePrimeiraConferencia})`}</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Box
                                                        sx={{
                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white
                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                color: themeName === "light" ? "black" : "auto",
                                                            },
                                                            '& .super-app-theme--cell': {
                                                                color: '#00e676',
                                                                fontWeight: '600',
                                                            },
                                                        }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            getRowId={(rows) => rows.codigo_Franquia}
                                                            rows={divisao2FranquiasRows}
                                                            columns={columnsDivs}
                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: {
                                                                        pageSize: 16,
                                                                        page: pagina,
                                                                    },
                                                                },
                                                            }}
                                                            pageSizeOptions={[16]}
                                                            //checkboxSelection
                                                            disableRowSelectionOnClick
                                                            disableColumnFilter
                                                            disableColumnMenu
                                                            columnVisibilityModel={{
                                                                logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                                quantidade_Empates: aceitaEmpate ? true : false
                                                            }}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            {divisao3FranquiasRows.length > 0 && (
                                                <Grid container padding={1}>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Typography variant="h6">{`${nomeDivisao3} (${nomePrimeiraConferencia})`}</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Box
                                                            sx={{
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                },
                                                                '& .super-app-theme--cell': {
                                                                    color: '#00e676',
                                                                    fontWeight: '600',
                                                                },
                                                            }}>
                                                            <DataGrid
                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                getRowId={(rows) => rows.codigo_Franquia}
                                                                rows={divisao3FranquiasRows}
                                                                columns={columnsDivs}
                                                                initialState={{
                                                                    pagination: {
                                                                        paginationModel: {
                                                                            pageSize: 16,
                                                                            page: pagina,
                                                                        },
                                                                    },
                                                                }}
                                                                pageSizeOptions={[16]}
                                                                //checkboxSelection
                                                                disableRowSelectionOnClick
                                                                disableColumnFilter
                                                                disableColumnMenu
                                                                columnVisibilityModel={{
                                                                    logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                                    quantidade_Empates: aceitaEmpate ? true : false
                                                                }}
                                                                sx={{
                                                                    fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                }}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {divisao4FranquiasRows.length > 0 && (
                                                <Grid container padding={1}>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Typography variant="h6">{`${nomeDivisao4} (${nomePrimeiraConferencia})`}</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Box
                                                            sx={{
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                },
                                                                '& .super-app-theme--cell': {
                                                                    color: '#00e676',
                                                                    fontWeight: '600',
                                                                },
                                                            }}>
                                                            <DataGrid
                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                getRowId={(rows) => rows.codigo_Franquia}
                                                                rows={divisao4FranquiasRows}
                                                                columns={columnsDivs}
                                                                initialState={{
                                                                    pagination: {
                                                                        paginationModel: {
                                                                            pageSize: 16,
                                                                            page: pagina,
                                                                        },
                                                                    },
                                                                }}
                                                                pageSizeOptions={[16]}
                                                                //checkboxSelection
                                                                disableRowSelectionOnClick
                                                                disableColumnFilter
                                                                disableColumnMenu
                                                                columnVisibilityModel={{
                                                                    logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                                    quantidade_Empates: aceitaEmpate ? true : false
                                                                }}
                                                                sx={{
                                                                    fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                }}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </Grid>
                                        <Grid container marginTop={1} size={{ xs: 12, sm: 6 }}>
                                            {!removeLoading && <Loading />}
                                            <Grid container padding={1} >
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Typography variant="h6">{`${nomeDivisao5} (${nomeSegundaConferencia})`}</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Box
                                                        sx={{
                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white
                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                color: themeName === "light" ? "black" : "auto",
                                                            },
                                                            '& .super-app-theme--cell': {
                                                                color: '#00e676',
                                                                fontWeight: '600',
                                                            },
                                                        }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            getRowId={(rows) => rows.codigo_Franquia}
                                                            rows={divisao5FranquiasRows}
                                                            columns={columnsDivs}
                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: {
                                                                        pageSize: 16,
                                                                        page: pagina,
                                                                    },
                                                                },
                                                            }}
                                                            pageSizeOptions={[16]}
                                                            //checkboxSelection
                                                            disableRowSelectionOnClick
                                                            disableColumnFilter
                                                            disableColumnMenu
                                                            columnVisibilityModel={{
                                                                logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                                quantidade_Empates: aceitaEmpate ? true : false
                                                            }}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <Grid container padding={1}>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Typography variant="h6">{`${nomeDivisao6} (${nomeSegundaConferencia})`}</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <Box
                                                        sx={{
                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white
                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                color: themeName === "light" ? "black" : "auto",
                                                            },
                                                            '& .super-app-theme--cell': {
                                                                color: '#00e676',
                                                                fontWeight: '600',
                                                            },
                                                        }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            getRowId={(rows) => rows.codigo_Franquia}
                                                            rows={divisao6FranquiasRows}
                                                            columns={columnsDivs}
                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: {
                                                                        pageSize: 16,
                                                                        page: pagina,
                                                                    },
                                                                },
                                                            }}
                                                            pageSizeOptions={[16]}
                                                            //checkboxSelection
                                                            disableRowSelectionOnClick
                                                            disableColumnFilter
                                                            disableColumnMenu
                                                            columnVisibilityModel={{
                                                                logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                                quantidade_Empates: aceitaEmpate ? true : false
                                                            }}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            {divisao7FranquiasRows.length > 0 && (
                                                <Grid container padding={1}>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Typography variant="h6">{`${nomeDivisao7} (${nomeSegundaConferencia})`}</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Box
                                                            sx={{
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                },
                                                                '& .super-app-theme--cell': {
                                                                    color: '#00e676',
                                                                    fontWeight: '600',
                                                                },
                                                            }}>
                                                            <DataGrid
                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                getRowId={(rows) => rows.codigo_Franquia}
                                                                rows={divisao7FranquiasRows}
                                                                columns={columnsDivs}
                                                                initialState={{
                                                                    pagination: {
                                                                        paginationModel: {
                                                                            pageSize: 16,
                                                                            page: pagina,
                                                                        },
                                                                    },
                                                                }}
                                                                pageSizeOptions={[16]}
                                                                //checkboxSelection
                                                                disableRowSelectionOnClick
                                                                disableColumnFilter
                                                                disableColumnMenu
                                                                columnVisibilityModel={{
                                                                    logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                                    quantidade_Empates: aceitaEmpate ? true : false
                                                                }}
                                                                sx={{
                                                                    fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                }}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {divisao8FranquiasRows.length > 0 && (
                                                <Grid container padding={1}>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Typography variant="h6">{`${nomeDivisao8} (${nomeSegundaConferencia})`}</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <Box
                                                            sx={{
                                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    color: themeName === "light" ? "black" : "auto",
                                                                },
                                                                '& .super-app-theme--cell': {
                                                                    color: '#00e676',
                                                                    fontWeight: '600',
                                                                },
                                                            }}>
                                                            <DataGrid
                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                getRowId={(rows) => rows.codigo_Franquia}
                                                                rows={divisao8FranquiasRows}
                                                                columns={columnsDivs}
                                                                initialState={{
                                                                    pagination: {
                                                                        paginationModel: {
                                                                            pageSize: 16,
                                                                            page: pagina,
                                                                        },
                                                                    },
                                                                }}
                                                                pageSizeOptions={[16]}
                                                                //checkboxSelection
                                                                disableRowSelectionOnClick
                                                                disableColumnFilter
                                                                disableColumnMenu
                                                                columnVisibilityModel={{
                                                                    logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                                    quantidade_Empates: aceitaEmpate ? true : false
                                                                }}
                                                                sx={{
                                                                    fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                }}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={2}>
                                    {!removeLoading && <Loading />}
                                    <Grid container direction="column" size={{ xs: 12, sm: 12 }}>
                                        <Box
                                            sx={{
                                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                '& .super-app-theme--header': {
                                                    backgroundColor: theme.palette.common.black,
                                                    color: theme.palette.common.white,
                                                },
                                                '& .super-app.negative': {
                                                    color: 'red',
                                                    fontWeight: 'bold'
                                                },
                                                '& .super-app.positive': {
                                                    color: themeName === "light" ? "black" : "auto",
                                                },
                                                '& .super-app-theme--cell': {
                                                    color: '#00e676',
                                                    fontWeight: '600',
                                                },
                                            }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                getRowId={(geralRows) => geralRows.codigo_Franquia}
                                                rows={classificacaoGeralrows}
                                                columns={columnsGeral}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 32,
                                                            page: pagina,
                                                        },
                                                    },
                                                }}
                                                pageSizeOptions={[32, 50]}
                                                disableRowSelectionOnClick
                                                disableColumnFilter
                                                disableColumnMenu
                                                columnVisibilityModel={{
                                                    logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                    quantidade_Empates: aceitaEmpate ? true : false
                                                }}
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={3}>
                                    {!removeLoading && <Loading />}
                                    <Grid container size={{ xs: 12, sm: 12 }} display={"flex"} spacing={1} >
                                        {classificacaoCopinharows.map(g => (
                                            <Grid container size={{ xs: 12, sm: 6 }}  >
                                                <Grid container size={{ xs: 12, sm: 12 }} padding={1}>
                                                    <Grid size={{ xs: 12, sm: 12 }} padding={1}>
                                                        <Typography variant="h6">{g.nome}</Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <TableContainer component={Paper} variant="outlined" sx={{ m: 0, width: "auto" }}>
                                                            <Table>
                                                                <TableHead>
                                                                    <StyledTableRow>
                                                                        <StyledTableCell width={100} align="center">POSIÇÃO</StyledTableCell>
                                                                        <StyledTableCell width={100} align="center">LOGO</StyledTableCell>
                                                                        <StyledTableCell width={100}>FRANQUIA</StyledTableCell>
                                                                        <StyledTableCell width={100} align="center">PONTOS</StyledTableCell>
                                                                        <StyledTableCell width={100} align="center">VITÓRIA</StyledTableCell>
                                                                        <StyledTableCell width={100} style={{ display: aceitaEmpate ? "block" : "none" }} align="center">EMPATE</StyledTableCell>
                                                                        <StyledTableCell width={100} align="center">DERROTA</StyledTableCell>
                                                                        <StyledTableCell width={100} align="center">SALDO</StyledTableCell>
                                                                        <StyledTableCell width={100} align="center">STATS</StyledTableCell>
                                                                    </StyledTableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {g.classificacao.length > 0 ?
                                                                        (g.classificacao.map((row, index) => (
                                                                            <StyledTableRow key={index}>
                                                                                <StyledTableCell align="center">
                                                                                    {row.posicao}
                                                                                    {/* {(
                                                                                        row.posicao_Anterior === 0 ?
                                                                                            <>
                                                                                                {row.posicao} <Remove sx={{ color: "#fbc02d", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} />
                                                                                            </>
                                                                                            : row.posicao < row.posicao_Anterior ?
                                                                                                <>
                                                                                                    {row.posicao}<ArrowUpward sx={{ color: "#66bb6a", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /> <span style={{ color: "#66bb6a", fontSize: UtilidadeService.isMobile() ? "small" : "small" }}>{Number(row.posicao_Anterior - row.posicao)}</span>
                                                                                                </>
                                                                                                : row.posicao > row.posicao_Anterior ?
                                                                                                    <>
                                                                                                        {row.posicao}<ArrowDownward sx={{ color: "#E91309", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} /> <span style={{ color: "#E91309", fontSize: UtilidadeService.isMobile() ? "small" : "small" }}>{Number(row.posicao - row.posicao_Anterior)}</span>
                                                                                                    </>
                                                                                                    : <>
                                                                                                        {row.posicao}<Remove sx={{ color: "#fbc02d", fontSize: UtilidadeService.isMobile() ? "small" : "medium" }} />
                                                                                                    </>
                                                                                    )} */}
                                                                                </StyledTableCell>
                                                                                <StyledTableCell align="center">{<img src={row.logo_Franquia !== null ? row.logo_Franquia : semImagemFranquia} width={UtilidadeService.isMobile() ? 20 : 40} height={UtilidadeService.isMobile() ? 20 : 40} />}</StyledTableCell>
                                                                                <StyledTableCell>{row.nome_Franquia}</StyledTableCell>
                                                                                <StyledTableCell align="center" style={{ color: "#00e676" }}>{row.pontos}</StyledTableCell>
                                                                                <StyledTableCell align="center">{row.quantidade_Vitorias}</StyledTableCell>
                                                                                <StyledTableCell align="center" style={{ display: aceitaEmpate ? "block" : "none" }}>{row.quantidade_Empates}</StyledTableCell>
                                                                                <StyledTableCell align="center">{row.quantidade_Derrotas}</StyledTableCell>
                                                                                <StyledTableCell align="center">{row.saldo}</StyledTableCell>
                                                                                <StyledTableCell align="center">{row.pontuacao_Stats}</StyledTableCell>
                                                                            </StyledTableRow>
                                                                        )
                                                                        ))
                                                                        : (
                                                                            <StyledTableRow  >
                                                                                <StyledTableCell colSpan={7} >Sem Informação</StyledTableCell>
                                                                            </StyledTableRow>
                                                                        )
                                                                    }
                                                                </TableBody>
                                                                <TableFooter>
                                                                    {isLoading && (
                                                                        <StyledTableRow>
                                                                            <StyledTableCell colSpan={7}>
                                                                                <LinearProgress variant="indeterminate" />
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                    )}
                                                                </TableFooter>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </TabPanel>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
        </LayoutBaseDePagina >
    );
};